import { VDBText } from "@components/atoms";
import { TouchableOpacity } from "react-native";
import { InputDrawerProps } from "./types";
import { cloneElement, isValidElement, useState } from "react";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { useTheme } from "styled-components/native";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import Modal from "@components/atoms/Modal";
import styled from "styled-components/native";
import { VDBIcons } from "@utils/VDBIcons";

const InputDrawer = ({
  children,
  itemText,
  headerTitle,
  iconName = VDBIcons.ARROW_DOWN,
  iconColor,
  borderRadius = 8,
  height = 56,
  showError = false,
}: InputDrawerProps) => {
  const [showHourModal, setShowHourModal] = useState(false);
  const typography = useTypographyStore();
  const theme = useTheme();
  const handleCloseModal = () => {
    setShowHourModal(false);
  };
  return (
    <>
      <TouchableOpacity
        onPress={() => {
          setShowHourModal(true);
        }}
      >
        <TopicDropdownView
          borderRadius={borderRadius}
          height={height}
          showError={showError}
        >
          <TopicContainer>
            <VDBText
              type={itemText ? typography["Body-M"] : typography["Body-R"]}
              color={itemText ? theme["core-05"] : theme["core-06"]}
            >
              {itemText || "Select option"}
            </VDBText>
          </TopicContainer>
          <IconContainer>
            <VDBIcon
              name={iconName}
              size={24}
              color={iconColor ? iconColor : theme["core-04"]}
              variant={IconsVariant.VDBCustom}
            />
          </IconContainer>
        </TopicDropdownView>
      </TouchableOpacity>
      <Modal
        headerTitle={headerTitle}
        isOpen={showHourModal}
        onClose={handleCloseModal}
        paddingLeft={0}
        paddingRight={0}
        paddingTop={0}
        paddingBottom={0}
      >
        {isValidElement(children)
          ? cloneElement(children, { closeModal: handleCloseModal })
          : children}
      </Modal>
    </>
  );
};

const TopicDropdownView = styled.View<{
  borderRadius: number;
  height: number;
  showError?: boolean;
}>`
  width: 100%;
  height: ${({ height }) => height}px;
  min-height: ${({ height }) => height}px;
  background-color: ${({ theme }) => theme["core-01"]};
  padding: ${({ height }) => (height <= 32 ? 0 : 8)}px 12px;
  border-radius: ${({ borderRadius }) => borderRadius}px;
  border-color: ${({ theme, showError }) =>
    showError ? theme["error-01"] : theme["core-04"]};
  border-width: 1px;
  flex-direction: row;
  justify-content: space-between;
`;

const TopicContainer = styled.View`
  flex: 1;
  align-self: center;
`;

const IconContainer = styled.View`
  align-self: center;
`;

export default InputDrawer;
